if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Инициализация галереи изображений в модалке
            setTimeout(() => {
              const galleryContainers = this.modalContent.querySelectorAll('.product-image-wrap');
              galleryContainers.forEach(container => {
                // Сбрасываем флаг инициализации для переинициализации
                delete container.dataset.galleryInitialized;
                if (window.ProductGalleryV2) {
                  new window.ProductGalleryV2(container);
                  container.dataset.galleryInitialized = 'true';
                } else {
                  // Если класс не экспортирован, инициализируем через событие
                  document.dispatchEvent(new CustomEvent('variant:change'));
                }
              });

              // Инициализация переключателя вариантов в модалке
              this.initVariantSelector();
            }, 100);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // Удаляем блок "Related Products" / "Смотрите также"
        const relatedProducts = productElement.querySelector('.product-related-wrapper');
        if (relatedProducts) relatedProducts.remove();

        // Удаляем complementary products если есть
        const complementaryProducts = productElement.querySelector('product-recommendations');
        if (complementaryProducts) complementaryProducts.remove();

        const complementarySection = productElement.querySelector('.complementary-products');
        if (complementarySection) complementarySection.remove();
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      initVariantSelector() {
        const container = this.modalContent;
        const weightItems = container.querySelectorAll('.product-text-weight-item');
        
        if (weightItems.length === 0) return;

        const priceElement = container.querySelector('.product-text-price-main');
        const comparePriceElement = container.querySelector('.product-text-price-sale');
        const addToCartButton = container.querySelector('.product-text-buy-btn');
        const addToCartButtonPrice = container.querySelector('.product-text-buy-btn-price');
        const variantInput = container.querySelector('input[name="id"]');

        // Получаем URL продукта из variant-selects или product-info
        const variantSelects = container.querySelector('variant-selects');
        const productInfo = container.querySelector('product-info');
        const productUrl = variantSelects?.dataset.url || productInfo?.dataset.url;

        if (productUrl) {
          fetch(`${productUrl}.js`)
            .then(response => response.json())
            .then(productData => {
              const variants = productData.variants;
              this.setupVariantListeners(weightItems, variants, {
                priceElement,
                comparePriceElement,
                addToCartButton,
                addToCartButtonPrice,
                variantInput,
                container
              });
            })
            .catch(err => console.error('Error loading variants:', err));
        }
      }

      setupVariantListeners(weightItems, variants, elements) {
        const { priceElement, comparePriceElement, addToCartButton, addToCartButtonPrice, variantInput, container } = elements;

        weightItems.forEach(item => {
          item.addEventListener('click', (e) => {
            const selectedItem = e.currentTarget;
            
            // Убираем активный класс со всех
            weightItems.forEach(i => i.classList.remove('active'));
            selectedItem.classList.add('active');

            const optionValue = selectedItem.dataset.variantValue;
            
            // Находим вариант
            const selectedVariant = variants.find(v => 
              v.option1 === optionValue || v.option2 === optionValue || v.option3 === optionValue
            );

            if (selectedVariant) {
              this.updateVariantUI(selectedVariant, elements);
            }
          });
        });
      }

      updateVariantUI(variant, elements) {
        const { priceElement, comparePriceElement, addToCartButton, addToCartButtonPrice, variantInput, container } = elements;

        // Форматирование цены
        const formatMoney = (cents) => {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount}}');
          }
          return `€${(cents / 100).toFixed(2)}`;
        };

        // Обновляем основную цену
        if (priceElement) {
          priceElement.textContent = formatMoney(variant.price);
          priceElement.dataset.price = variant.price;
        }

        // Обновляем цену со скидкой
        if (comparePriceElement) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceElement.textContent = formatMoney(variant.compare_at_price);
            comparePriceElement.style.display = '';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }

        // Обновляем кнопку
        if (addToCartButton) {
          const buttonText = addToCartButton.querySelector('.t2');
          if (variant.available) {
            addToCartButton.disabled = false;
            if (buttonText) {
              buttonText.textContent = window.variantStrings?.addToCart || 'В корзину';
            }
          } else {
            addToCartButton.disabled = true;
            if (buttonText) {
              buttonText.textContent = window.variantStrings?.soldOut || 'Распродано';
            }
          }
        }

        // Обновляем цену в кнопке
        if (addToCartButtonPrice) {
          addToCartButtonPrice.textContent = formatMoney(variant.price);
        }

        // Обновляем input с ID варианта
        if (variantInput) {
          variantInput.value = variant.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Обновляем изображение если есть
        if (variant.featured_media) {
          const mainImage = container.querySelector('.product-img img');
          if (mainImage && variant.featured_media.src) {
            mainImage.src = variant.featured_media.src;
          }
        }

        // Отправляем событие изменения варианта
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant },
          bubbles: true
        }));
      }
    }
  );
}
